import {
  CarRental,
  CarRepair,
  Chair,
  CleaningServices,
  Computer,
  Construction,
  ContactPageOutlined,
  Diamond,
  ElectricalServices,
  Event,
  ExpandLess,
  ExpandMore,
  ForkLeftOutlined,
  Help,
  Home,
  Info,
  Interests,
  MiscellaneousServices,
  PanToolSharp,
  Person,
  Plumbing,
  PresentToAll,
  PresentToAllSharp,
  RequestPage,
  Restaurant,
  RestaurantMenu,
  Settings,
  Shop,
  ShoppingCart,
} from '@mui/icons-material';
import Blog from '../../pages/Blog/Blog';
import BuyAndSell from '../../pages/BuyAndSell/BuyAndSell';
import SearchWork from '../../pages/FindJobs/SearchWork';
import SignIn from '../../pages/gene20Authetication/signIn/components/signIn';
import SignUp from '../../pages/gene20Authetication/signUp/signUp';
import MallShops from '../../pages/MallShops';
import ClothesAndJewellery from '../../pages/MallShops/categories/clothes&jewellery';
// import HomePage from "../../pages/HomePage/HomePage";
import Gene20Presents from '../../pages/presentation/presentationII';
import ProfilePage from '../../pages/Profile/ProfilePage';
import TheMall from '../../pages/TheMall/theMall';

const PageRoutesData = [
  {
    type: 'no-collapse',
    name: 'home',
    key: 'home',
    icon: <Home />,
    route: '/home',
    component: <Gene20Presents />,
  },
  {
    type: 'no-collapse',
    name: 'deals',
    key: 'deals',
    icon: <Interests />,
    route: '/deals',
    component: <Gene20Presents />,
  },
  {
    type: 'collapse',
    name: 'shops by category',
    key: 'shops by category',
    icon: <Shop />,
    route: '/shop',
    iconOpen: <ExpandLess />,
    iconClosed: <ExpandMore />,
    component: <TheMall />,
    collapse: [
      {
        type: 'collapse',
        name: 'clothes and jewellery',
        key: 'clothes and jewellery',
        icon: <Diamond />,
        route: '/shop/clothes',
        component: <MallShops />,
      },
      {
        type: 'collapse',
        name: 'cars and motorcycles',
        key: 'cars and motorcycles',
        icon: <CarRental />,
        route: '/shop/carshop',
        component: <BuyAndSell />,
      },
      {
        type: 'collapse',
        name: 'machinery equipment',
        key: 'machinery equipment',
        icon: <PanToolSharp />,
        route: '/searchwork',
        component: <SearchWork />,
      },
      {
        type: 'collapse',
        name: 'furniture and appliances',
        key: 'furniture and appliances',
        icon: <Chair />,
        route: '/blog',
        component: <Blog />,
      },
      {
        name: 'food and restuarants',
        key: 'food and restuarants',
        icon: <RestaurantMenu />,
        route: '/foodnrestuants',
        component: <Blog />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'services by category',
    key: 'services by category',
    icon: <MiscellaneousServices />,
    route: '/services',
    iconOpen: <ExpandLess />,
    iconClosed: <ExpandMore />,
    component: <TheMall />,
    collapse: [
      {
        name: 'it services',
        key: 'it services',
        icon: <Computer />,
        route: '/services/itservices',
        component: <TheMall />,
      },
      {
        name: 'events',
        key: 'events',
        icon: <Event />,
        route: '/services/eventsncatering',
        component: <BuyAndSell />,
      },
      {
        name: 'catering',
        key: 'catering',
        icon: <Restaurant />,
        route: '/services/eventsncatering',
        component: <BuyAndSell />,
      },
      {
        name: 'construction',
        key: 'construction',
        icon: <Construction />,
        route: '/services/constructionnmaintanance',
        component: <SearchWork />,
      },
      {
        name: 'plumbing',
        key: 'plumbing',
        icon: <Plumbing />,
        route: '/blog',
        component: <Blog />,
      },
      {
        name: 'electricals',
        key: 'electricals',
        icon: <ElectricalServices />,
        route: '/services/electricals',
        component: <Blog />,
      },
      {
        name: 'gardening',
        key: 'gardening',
        icon: <ForkLeftOutlined />,
        route: '/foodnrestuants',
        component: <Blog />,
      },
      {
        name: 'cleaning',
        key: 'food and restuarants',
        icon: <CleaningServices />,
        route: '/foodnrestuants',
        component: <Blog />,
      },
    ],
  },
  {
    type: ' collapse',
    name: 'orders',
    key: 'orders',
    icon: <RequestPage />,
    route: '/orders',
    component: <TheMall />,
  },
  {
    type: 'collapse',
    name: 'cart',
    key: 'cart',
    icon: <ShoppingCart />,
    route: '/cart',
    component: <BuyAndSell />,
  },
  {
    type: 'collapse',
    name: 'my account',
    key: 'my account',
    icon: <Person />,
    route: '/accounts',
    component: <SearchWork />,
    iconOpen: <ExpandLess />,
    iconClosed: <ExpandMore />,
    collapse: [
      {
        name: 'profile settings',
        key: 'profile settings',
        icon: <Settings />,
        route: '/profile',
        component: <TheMall />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'help centre',
    key: 'help centre',
    icon: <Help />,
    route: '/help',
    component: <Blog />,
  },
];

export default PageRoutesData;
